export const REALM_ARCHIVED_LABEL = 'Galaxy';

export const formatApproval = (approved: boolean, approver?: string, approvedAt?: string) => {
  if (!approved) return 'Pending';
  const name = approver || '';
  const date = approvedAt || '';
  return name && date ? `${name} (${date})` : name || date;
};
